import React from 'react';
import {ModalProvider} from 'react-modal-hook';
import {Provider} from 'react-redux';
import {GalleryRoot} from './GalleryRoot';
import {createGalleryStore} from '~/GalleryPB/reducers';
import {getGalleryDataCallback} from '~/GalleryPB/api/galleryData';

const store = createGalleryStore({});
window.setGalleryDataCallback(getGalleryDataCallback(store));

export const GalleryRootWrapper = () => (
  <ModalProvider>
    <Provider store={store}>
      <GalleryRoot />
    </Provider>
  </ModalProvider>
);
